import React, { useEffect, useState } from "react";

export default function FilterCheckbox({
    item,
    selected,
    selectedItems,
    param,
    multi,
    style,
    className = "",
    onSelect
}) {
    const [check, setCheck] = useState(false);

    useEffect(() => {
        if (selectedItems === undefined) setCheck(selected);
        else setCheck(!!selectedItems.find(el => el.id == item.id || el.old_id == item.id));
    }, [selectedItems, selected]);

    function selectItem() {
        onSelect({ id: item.id, param, title: item.title, multi });
    }

    return (
        <label className={`filter-checkbox-container ${className}`} style={style}>
            <span>
                {item.title} 
                {item.count != null && <span className="filter-checkbox-container-count">({item.count})</span>}
            </span>
            <input type="checkbox" checked={check} onChange={selectItem} />
            <div className="checkmark" />
        </label>
    );
}
